$(function() {
    function checkPhoneFormat(phoneRpl, element) {
        var _this = element;
      var regex=/^[0-9]+$/;
      if (!phoneRpl.match(regex) || phoneRpl.length != 8 ) {
        if($('#error-for-phone').length > 0) {
          $('#error-for-phone span').remove();
          $('#error-for-phone').append('<span>. Phone Number format to contain 8 digits</span>');
        }else {
          $(_this).parent().append('<p class="field__message field__message--error" id="error-for-phone">Enter a valid phone number<span>. Phone Number format to contain 8 digits</span></p>');
        }
        $(_this).parents('form').addClass('field--error');
        event.preventDefault();
        return false;
      }else {
          $(_this).parents('form').removeClass('field--error');
      }
  }

  if($('.product-options .selector-wrapper').length > 0) {
      $('.product-options .single-option-selector option').each(function() {
          var valueOpt = $(this).val();
          var wapperCLaction = $(this).parents('.product-options');
          var dataSlQty = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-quantity');
          var dataVariantId = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-variant-id');
          if($('.list.collection-list').length > 0) {
            var dataPrice = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-price');
            var dataCompareAtPrice = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-compare_at_price');
            var dataPriceSave = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-price_save');
            $(this).attr('data-price',dataPrice);
            $(this).attr('data-compare_at_price',dataCompareAtPrice);
            $(this).attr('data-price_save',dataPriceSave);
          }
          $(this).attr('data-quantity',dataSlQty);
          $(this).attr('data-variant',dataVariantId);
      });
  }
  if($('.product-wrap #quantity').length > 0) {
      var input = $('.product-wrap #quantity');
      var dataQuantity = $(input).attr('data-quantity');
      input.keyup(function() {
          var newResult = parseFloat(input.val());
          if($('.product-options .selector-wrapper').length > 0) {
              dataQuantity = $('.product-options .single-option-selector option:selected').attr('data-quantity');
          }
          if(newResult > dataQuantity) {
              input.val(1);
              alert('The quantity being add to cart exceed the actual inventory');
          }
      });
  }

  $('body').on('click', '#create_customer .cta-container .button', function() {
      var x = document.getElementById("agree").required;
  });

    if($('.customer-addresses form input[name="address[phone]"]').length > 0) {
        var phone_regex = '[1-9][0-9]{7}';
        $('.customer-addresses form input[name="address[phone]"]').inputmask({
          regex: "^" + phone_regex +"$"
        });

        $('.customer-addresses form input[name="address[phone]"]').on("keyup", function() {
            var phoneVal = $(this).val();
            var phoneRpl = phoneVal.replace(" ", "");
            checkPhoneFormat(phoneRpl,this);
        });
        
        $('.customer-addresses input[type="submit"]').click(function(){
            var inputPhone = $(this).parents('form').find('input[name="address[phone]"]');
            var phoneVal = $(inputPhone).val();
            var phoneRpl = phoneVal.replace(" ", "");
            checkPhoneFormat(phoneRpl,'.customer-addresses form input[name="address[phone]"');
        });
    }
    
    if($('#editAddress').length > 0) {
        var addresssID = $('#accountAddress').attr('data-addressID');
        $('#editAddress').click(function() {
            $('.account-detail').addClass('show');
        });
        $('.cancel-edit').click(function() {
            $('.account-detail').removeClass('show');
            return false;
        });
        
        $('#submitUpdate').click(function(){
            var phoneVal = $('.customer-addresses form input[name="address[phone]"]').val();
            var phoneRpl = phoneVal.replace(" ", "");
            
            var statusForm = checkPhoneFormat(phoneRpl,'.customer-addresses form input[name="address[phone]"');
            if(statusForm !== false) {
                var data = $('#address_form_'+ addresssID).serialize();
                var urlAdddress = '/account/addresses/'+addresssID;
                $.ajax({
                    type: "post",
                    url: urlAdddress,
                    data: data, 
                    beforeSend: function() {
                        $('.account-detail').addClass('loadding');
                    },
                    success: function(msg) {
                        location.reload();
                    },
                    error: function(xhr, text) {
                    alert('something error');
                    }
                });
            }            
        });
    }
    
    // Filter collection
    if($('.filter-sidebar').length > 0) {
        $('.filter-sidebar .block-title h3').click(function(){
//             var dataAttTitleFilter = $(this).attr("data-content");
//             var checkSSFilter = sessionStorage.getItem(dataAttTitleFilter);
//             if(checkSSFilter === null) {
//                 sessionStorage.setItem(dataAttTitleFilter, '1');
//             }else {
//                 if(checkSSFilter == '1') {
//                 sessionStorage.setItem(dataAttTitleFilter, '0');
//                 }else {
//                 sessionStorage.setItem(dataAttTitleFilter, '1');
//                 }
//             }
            $(this).parents('.block').toggleClass('show');
        });
      
      // if input checked => show item
      $( '.filter-sidebar > .block' ).each(function( index ) {
        // get item
        var listItemFilter = $(this).find('.block-content ul li');        
        $(listItemFilter).each(function( index ) {
          // Get input
          var inputCheck = $(this).find('input[type=checkbox]');
          if(inputCheck.is(':checked') == true) {
            $(this).parents('.block').addClass('show');
          	return false;
          }
        });
      });
    }

    // Collection action add to cart
    $('.cl-product-action .icon-plus').click(function() {
      	var wrapAction = $(this).parents('.cl-product-action');
      	var inputQt = $(this).parents('.cl-product-action').find('input.quantity');
      	var dataQuantity = 1;
      	// view detail
      	if($('.product-wrap .product-details').length > 0) {
          if($(wrapAction).find('.single-option-selector').length > 0){
          	dataQuantity = $(wrapAction).find('.product-select[name="id"] option:selected').attr('data-quantity');
          }else {
          	dataQuantity = $(wrapAction).find('input.quantity').attr('data-quantity');
          }          
        }else {
          // view list
          if($(wrapAction).find('.single-option-selector').length > 0) {
            dataQuantity = $(wrapAction).find('.single-option-selector option:selected').attr('data-quantity');
          }else {
          	dataQuantity = $(wrapAction).find('input.quantity').attr('data-quantity');
          }
        }
      	
        var inputQtVal = parseFloat($(inputQt).val());
        if((inputQtVal + 1) > dataQuantity) {
            alert('The quantity being add to cart exceed the actual inventory');
        }else {
            $(inputQt).val(inputQtVal + 1);
        }
    });
    $('.cl-product-action .icon-minus').click(function() {
        var inputQt = $(this).parents('.cl-product-action').find('input.quantity');
        var inputQtVal = parseFloat($(inputQt).val());
        if(inputQtVal > 1) {
            $(inputQt).val(inputQtVal - 1);
        }
    });

    // Change variant page collection
    $('.single-option-selector').change(function(){
      if($('.product-wrap .product-details').length > 0) {
        
      }else {
        // get wrapitem and dom currentPrice
        var wrapItem = $(this).parents('.list-item');
        var currentPrice = $(wrapItem).find('.price > .money:not(.original)');
        // get prices of option seleted
        var dataPrice = $('option:selected', this).attr('data-price');
      	
        var dataComparePrice = $('option:selected', this).attr('data-compare_at_price');
        
        // parseFloat prices to compare
        var initdataPrice = parseFloat(dataPrice.replace(/[^0-9]/g,''));
        var initdataPriceCompare = parseFloat(dataComparePrice.replace(/[^0-9]/g,''));
        // compare prices
        if(initdataPriceCompare > initdataPrice) {            
            var priceSave = $('option:selected', this).attr('data-price_save');
            $(wrapItem).removeClass('no_compare');
            if($(wrapItem).find('.price .original').length > 0) {
                $(wrapItem).find('.price .original').text(dataComparePrice);
            }else {
                // $(wrapItem).find('.list-meta > .price').append('<span class="class="original money"">'+ dataComparePrice +'</span><span class="saving">saving</span><span class="saving-result money">'+ priceSave +'</span>');
            }
            if($(wrapItem).find('.saving-result.money').length > 0) {
                $(wrapItem).find('.saving-result.money').text(priceSave);
            }else {
                if($(wrapItem).find('.list-meta .saving').length > 0) {
                    $(wrapItem).find('.list-meta .saving').append('saving <span class="saving-result money"> '+ priceSave +'</span>');
                }
            }
        }else {
            $(wrapItem).addClass('no_compare');
        }
        $(currentPrice).text(dataPrice);

        var dataVariant = $('option:selected', this).attr('data-variant');
        if ($(wrapItem).find('img.list-image-'+dataVariant).length > 0) {
          $(wrapItem).find('img.list-image').addClass('hidden');
          $(wrapItem).find('img.list-image-'+dataVariant).removeClass('hidden');
        } else {
          $(wrapItem).find('img.list-image:first-child').removeClass('hidden');
        }
      }
        
    });
  
  function updateURLSearch(val) {
    // var arr = val.split(" ");
    // var query = '';
    // $.each(arr,function(index,value){
    //   query += value+"+";
    // });
    // var href = "/search/?q="+query+"-invisible&&type=product";
    var href = "/search/?q="+val+"*&type=product";
    $(location).attr('href', href);
  }
  
  // Search
  $('.header-search-input').on('keypress',function(e) {
    if(e.which == 13) {
      e.preventDefault();
      var input_search = $(this).val();
      updateURLSearch(input_search);
    }
  });
  
  $("#SearchResultSubmit").click(function(e) {
    e.preventDefault();
    var input_search = $('#SearchInput').val();
    updateURLSearch(input_search);
  });
  
  // js ly translation langify
  
//   $('body').on('change', '#header-mobile-ly-languages #ly-languages-switcher', function(e) {
//     var x = $(this).find(":selected").val();
//     $('#ly-languages-switcher-desktop #ly-languages-switcher').val(x).change();
//     console.log(x);
//     return false;    
  	
//   });
  
  if($('#ly-languages-switcher-desktop').length > 0) {
  	let getWidthWin = $( window ).width();
    if(getWidthWin <= 767) {
      $('#ly-languages-switcher-desktop').appendTo('#header-mobile-ly-languages');
    }
  }
});


$(window).load(function() {
    // cookie    
    var windowWidth = $( window ).width();
    if(windowWidth <= 720) {
        var footerOfTop = $('.footer-wrapper').offset().top;    
        $( window ).scroll(function() {
            var scrollPosition = $(window).scrollTop();
            if($('.cc-theme-block').length > 0) {
                if(scrollPosition >= footerOfTop) {
                        $('.cc-theme-block').addClass('ps-relative');
                }else {
                    $('.cc-theme-block').removeClass('ps-relative');
                }
            }      
        });
    }
  
  
  // CartPage
  function checkCartPageDisscount() {
    // Look for Advance Product Options parameters.
    var options = $('.saso-cart-total').is(':empty');
    console.log(options);
    if (options && (!checkCartPageDisscount.retry || checkCartPageDisscount.retry <= 100)) {      
      checkCartPageDisscount.retry = checkCartPageDisscount.retry ? checkCartPageDisscount.retry + 1 : 1;
      setTimeout(checkCartPageDisscount, 100);
    }
    else if (!options) {
      if($('.saso-cart-total .saso-use-discount-instead-container').length > 0) {
        $('.saso-cart-total').addClass('title_hidden');
      }else {
        $('.saso-cart-total').addClass('title_show');
      }      
    }
  }
  if($('.saso-cart-total').length > 0) {
  	checkCartPageDisscount();
  }
  
  // PAGE GLOBAL NETWORK
  $('.page-network-container .country-container .country-name').click(function(){
    var liParent      = $(this).parents('li');
    var offOverlay    = $(liParent).find('.offices-overlay');
    var liOffsetLeft  = $(liParent).offset().left;
    var warpOffsetLeft = $('.page-network-container').offset().left;
    var leftOverlay   = 0 - (liOffsetLeft - warpOffsetLeft);
    if(offOverlay.hasClass('active')) {
      offOverlay.removeClass('active');
      $(offOverlay).slideUp();
    }else {
      $('.offices-overlay').hide();
      $('.country-container li .offices-overlay').removeClass('active');
      $(offOverlay).css("left",leftOverlay);
      $(offOverlay).slideDown();
      $(offOverlay).addClass('active');
    }
  });
  $('.offices-overlay a.close').click(function() {
    $('.offices-overlay').hide();
    $('.offices-overlay').removeClass('active');
  });
  // END GLOBAL NETWORK
  
  // Page Career
  $('.Careercontent .CareerNav a').click(function(e){
    e.preventDefault();
    let idNav = $(this).attr('href');
    let offsetNav = $(idNav).offset().top;
    let widthWindow = $(window).width();
    if($('.header.sticky-header').length > 0 && widthWindow > 767) {
      var heightHeader = $('.header.sticky-header').height();
      offsetNav = offsetNav - heightHeader;
    }
    $('html, body').animate({
      scrollTop: offsetNav
    }, 1000);
  });
  // End Page Career

  // Page Career
  $('#awards-btn > li').on('click', function(){
		awardsLiIndex = $(this).index();
		$('#awards-btn > li').removeClass('active');
		$('#awards-box > li').removeClass('active');
		$(this).addClass('active');
		$('#awards-box > li:eq('+ awardsLiIndex +')').addClass('active');
	});
  // End Page Career
  
});

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateImage();
      this.updateURL();
      this.updateVariantInput();
      this.updateExternalUrls();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateImage() {
    if (!this.currentVariant || !this.currentVariant.featured_image) return;
    const ELM_imageThumbnail = document.querySelector(`[data-product-image-thumbnail][data-image-id="${ this.currentVariant.featured_image.id }"]`);

    if (ELM_imageThumbnail) {
      ELM_imageThumbnail.click();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateExternalUrls() {
    const ELM_clProductAction = this.closest('.cl-product-action[data-product-external-urls]');
    const externalURLs = JSON.parse(ELM_clProductAction?.dataset?.productExternalUrls || '{}');
    if (!externalURLs || !Object.keys(externalURLs).length) return;
    
    const variantExternalURLs = externalURLs[this.currentVariant.id]
    const ELM_btnWrappers = ELM_clProductAction.querySelectorAll('.external-buttons');
    ELM_btnWrappers.forEach(btnWrapper => {
      const btns = btnWrapper.querySelectorAll('.external-btn');
      btns?.forEach(btn => btn.classList.add('hidden'));

      if (!variantExternalURLs.length) {
        return btnWrapper.querySelector('.external-btn.coming-soon')?.classList.remove('hidden');
      }
      
      let buttonsHtml = '';
      variantExternalURLs.forEach(item => {
        const { platform, url, icon, title } = item;
        const childElm = btnWrapper.querySelector(`.${platform}-checkout-btn`);
        if (childElm) {
          childElm.classList.remove('hidden');
          if (childElm.href != url) {
            childElm.href = url;
          }
        } else {
          buttonsHtml += `<a class="external-btn ${ platform }-checkout-btn" href="${ url }" target="_blank">
            <img src="${ icon }">
            <span class="external-btn-text">${ title }</span>
          </a>`
        }
      })

      if (buttonsHtml) {
        btnWrapper.innerHTML = btnWrapper.innerHTML + buttonsHtml;
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings?.soldOut || 'Sold out');
        this.refreshAfterpayPrice(html);
      });
  }

  refreshAfterpayPrice(html) {
    const id = `afterpay-price-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (addButtonText) {
        addButtonText.textContent = window.variantStrings?.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    if (addButtonText) {
      addButtonText.textContent = window.variantStrings?.unavailable;
    }
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Recyko batteries chargers tabs
(function() {
  const tabNav = document.querySelector('.page-recyko-product-tab-nav');
  const tabNavItems = tabNav?.querySelectorAll('a');
  const tabs = document.querySelectorAll('.page-recyko-product-tab');

  if (!tabNavItems || !tabs) return;
  tabNavItems[0]?.classList.add('active');
  tabs[0]?.classList.add('active');
  tabNavItems.forEach((tabNavItem, idx) => {
    tabNavItem.addEventListener('click', () => {
      tabNavItems.forEach((item, i) => {
        if (i === idx) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      })
      tabs.forEach((item, i) => {
        if (i === idx) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      })
    })
  })
})();